<template>
	<div style="width: 95%;margin: 0 auto;">
		<div
			style="width: 100%;height: 30px;border-left: 3px solid red;margin-top: 25px;font-size: 24px;font-weight: 800;padding-left: 25px;">
			认证管理
		</div>
		
		<div style="width: 100%;height: 50px;margin-top: 25px;">
			<div @click="qyrz" style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;float: left;margin-left: 5px;">
				企业认证
			</div>
			<div @click="grrz" style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;float: left;margin-left: 5px;">
				个人认证
			</div>
			<div @click="isShow = !isShow" style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;float: left;margin-left: 5px;">
				点击添加认证管理
			</div>
		</div>

		<!-- <div style="width: 90%;margin-left: 3%;height: 40px;margin-top: 25px;box-shadow: #6e6e6e 0px 0px 10px;">
			<div @click="qyrz"
				style="width: 120px;height: 40px;font-weight: 800;text-align: center;line-height: 40px;font-size: 18px;margin-left: 20px;border: 1px solid #6e6e6e;box-sizing: border-box;float: left;">
				企业认证
			</div>
			<div @click="grrz"
				style="width: 120px;height: 40px;font-weight: 800;text-align: center;line-height: 40px;font-size: 18px;margin-left: 20px;border: 1px solid #6e6e6e;box-sizing: border-box;float: left;margin-left: 10px;">
				个人认证
			</div>
			<div @click="isShow = !isShow"
				style="width: 120px;height: 40px;font-weight: 800;text-align: center;line-height: 40px;font-size: 18px;margin-left: 20px;border: 1px solid #6e6e6e;box-sizing: border-box;float: left;margin-left: 10px;">
				添加
			</div>
		</div> -->

		<div style="width: 100%;min-height: 300px;margin-top: 25px;">
			<div v-show="!isShow" style="min-height: 300px;text-align: center;">
				<div v-show="is_Showid==1" style="width: 100%;min-height: 300px;">
					<!-- 暂无选中内容（企业认证内容） -->
					<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;"
						v-for="(item,index) in neirong">
						<div style="width: 50%;height: 100px;float: left;">
							<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;font-size: 20px;font-weight: 800;color: #000;float: left;overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;">
								{{item.title}}
							</div>
							<div v-show="item.status=='0'"
								style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
								待审核
							</div>
							<div v-show="item.status=='1'"
								style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
								待审核
							</div>
							<div v-show="item.status=='2'"
								style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
								待审核
							</div>
							<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
								<span class="el-icon-time"></span>
								<span>发布时间：</span>{{getLocalTime(item.create_time)}}
							</div>
						</div>
						<div style="width: 50%;height: 100px;float: left;position: relative;">
							<div @click="xiugaia(item)"
								style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;">
								修改
							</div>
							<!-- <div
								style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;color: blue;">
								查看
							</div> -->
							<div @click="detela(item.id,item.mid)"
								style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;">
								删除
							</div>
						</div>
					</div>
				</div>
				<div v-show="is_Showid==2" style="width: 100%;min-height: 300px;">
					<!-- 暂无选中内容（个人认证内容） -->
					<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;"
						v-for="(item,index) in neirongs">
						<div style="width: 50%;height: 100px;float: left;">
							<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;font-size: 20px;font-weight: 800;color: #000;float: left;overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;">
								{{item.title}}
							</div>
							<div v-show="item.status=='0'"
								style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
								待审核
							</div>
							<div v-show="item.status=='1'"
								style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
								待审核
							</div>
							<div v-show="item.status=='2'"
								style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
								待审核
							</div>
							<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
								<span class="el-icon-time"></span>
								<span>发布时间：</span>{{getLocalTime(item.create_time)}}
							</div>
						</div>
						<div style="width: 50%;height: 100px;float: left;position: relative;">
							<div  @click="xiugaia(item)"
								style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;">
								修改
							</div>
							<!-- <div
								style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;color: blue;">
								查看
							</div> -->
							<div  @click="detela(item.id,item.mid)"
								style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;">
								删除
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-show="isShow" style="width: 100%;min-height: 300px;">
				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						所属分类:
					</div>
					<el-radio-group v-model="form.fid" @change="qwqa(form.fid)" style="margin-top: 5px;">
						<el-radio-button label="8">个人认证</el-radio-button>
						<el-radio-button label="9">企业认证</el-radio-button>
					</el-radio-group>
				</div>

				<div style="width: 100%;height: 50px;" v-show="grrza">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						姓名:
					</div>
					<el-input v-model="form.title" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;margin-top: 30px;" v-show="!grrza">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						账号:
					</div>
					<el-input v-model="form.title" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;" v-show="grrza">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						身份证号码:
					</div>
					<el-input v-model="form.cardnum" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						身份证正面:
					</div>
					<el-upload class="upload-demo" style="width: 200px;float: left;margin-top: 10px;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListss">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>

				<div style="width: 100%;height: 50px;margin-top: 30px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						身份证反面:
					</div>
					<el-upload class="upload-demo" style="width: 200px;float: left;margin-top: 10px;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccesss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileLists">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>

				<div style="width: 100%;height: 50px;margin-top: 30px;" v-show="!grrza">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						企业图片:
					</div>
					<el-upload class="upload-demo" style="width: 200px;float: left;margin-top: 10px;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccess" :limit="1"
						:on-exceed="handleExceed" :file-list="fileList">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>

				<div style="height: 50px;width: 200px;margin: 0 auto;">
					<el-button type="primary" @click="onSubmit">立即创建</el-button>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				isShow: false,
				is_Showid: 1,
				fileListss: [],
				fileLists: [],
				fileList: [],
				grrza: false,
				xgs: false,
				rzgla: '2',
				neirong: '',
				neirongs: '',
				ppid:'',
				form: {
					fid: '9', //分类栏目id
					title: '', //姓名
					cardnum: '', //身份证号码
					cardback: '', //身份证反面
					cardfont: '', //身份证正面
					picture: '', //企业图片
				}
			}
		},
		mounted() {
			this.qyrza()
		},
		methods: {
			qyrz() {
				this.isShow = false
				this.is_Showid = 1
				this.rzgla = '3'
				this.qyrza()
			},
			xiugaia(item){
				let fileArrss = [];
				let fileObjss = {};
				let fileArrs = [];
				let fileObjs = {};
				this.isShow = true
				this.xgs = true
				this.form.title = item.title
				fileObjss.name="身份证正面"
				fileObjss.url = item.cardfont
				fileArrss.push(fileObjss)
				this.fileListss  = fileArrss
				fileObjs.name="身份证反面"
				fileObjs.url = item.cardback
				fileArrs.push(fileObjs)
				this.fileLists  = fileArrs
				this.ppid = item.id
				
				if(item.mid==3){
					this.form.cardnum = item.cardnum
					this.form.fid = '8'
				} else {
					this.form.fid = '9'
					let fileArr = [];
					let fileObj = {};
					fileObj.name="企业图片";
					fileObj.url = item.picture;
					fileArr.push(fileObj);
					this.fileList  = fileArr
				}
			},
			async detela(val,val1){
				let res = await http.post('api/Common/delete',{
					model:'renzheng',
					type:'content',
					mid:val1,
					field_name:'id',
					field_id:val
				})
				if(val1 == 2){
					this.qyrza()
				}else{
					this.grrzaa()
				}
			},
			grrz() {
				this.isShow = false
				this.is_Showid = 2
				this.rzgla = '2'
				this.grrzaa()
			},
			async onSubmit() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (this.xgs == true) {
					let res = await http.post('api/Common/edit', {
						id: this.ppid,
						model: 'renzheng',
						type: 'content',
						mid: this.rzgla,
						fid: this.form.fid,
						title: this.form.title,
						cardnum: this.form.cardnum,
						cardfont: this.form.cardfont,
						cardback: this.form.cardback,
						picture: this.form.picture,
						uid: loginInfo.id
					})
					if (res.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '上传成功',
							type: 'success'
						});
						this.form.fid = '9'
						this.form.title = ''
						this.form.cardnum = ''
						this.form.cardback = ''
						this.form.cardfont = ''
						this.form.picture = ''
						this.fileListss = []
						this.fileLists = []
						this.fileList = []
					}
				} else if (this.xgs == false) {
					let res1 = await http.post('api/Common/add', {
						model: 'renzheng',
						type: 'content',
						mid: this.rzgla,
						fid: this.form.fid,
						title: this.form.title,
						cardnum: this.form.cardnum,
						cardfont: this.form.cardfont,
						cardback: this.form.cardback,
						picture: this.form.picture,
						uid: loginInfo.id
					})
					if (res1.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '上传成功',
							type: 'success'
						});
						this.form.fid = '9'
						this.form.title = ''
						this.form.cardnum = ''
						this.form.cardback = ''
						this.form.cardfont = ''
						this.form.picture = ''
						this.fileListss = []
						this.fileLists = []
						this.fileList = []
					}
				}
			},
			handlePreview(file) {
			},
			//个人
			async qyrza() {
				this.rzgla = '2'
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/Common/index', {
					model: 'renzheng',
					type: 'content',
					mid: this.rzgla,
					uid: loginInfo.id
				})
				this.neirong = res.data.data.list.data
			},
			//企业
			async grrzaa() {
				this.rzgla = '3'
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/Common/index', {
					model: 'renzheng',
					type: 'content',
					mid: this.rzgla,
					uid: loginInfo.id
				})
				this.neirongs = res.data.data.list.data
			},
			handleRemove(file, fileList) {
			},
			handsuccessss(response, file, fileList) {
				this.form.cardfont = response.data.path
			},
			handsuccess(response, file, fileList) {
				this.form.picture = response.data.path
			},
			handsuccesss(response, file, fileList) {
				this.form.cardback = response.data.path
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
			},
			qwqa(val) {
				if (val == '8') {
					this.grrza = true
					this.rzgla = '3'
				} else if (val == '9') {
					this.grrza = false
					this.rzgla = '2'
				}
			},
		}
	}
</script>

<style>
</style>
